<header class="ratings-content-header">
  <div class="details">
    <img
      class="card-icon"
      src="https://files.topo.ai/partners/logos/Crisis24.svg" />
    <span class="layer-name">{{ 'MAP.HORIZON-LOCATION-INTEL-RATINGS.CARD-HEADER-TEXT' | translate }}</span>
  </div>

  @if (showActions) {
    <div
      class="actions"
      >
      @if (!hideRatingsExpand) {
        <i
          class="icon icon-expand"
        (click)="showRatingsDetails($event)"></i>
      }
      <i
        class="icon icon-zoom-to_location"
      (click)="zoomToDocument()"></i>
    </div>
  }
</header>
